@let isMobile = deviceService.isMobile$ | async;

@if (user) {
  <p-dialog
    (visibleChange)="$event ? null : close()"
    [header]="'users.form.header-update' | translate"
    [modal]="true"
    [visible]="opened"
    class="dialog-primary {{ isMobile ? 'dialog-content-flex f-d-col' : 'medium' }}"
    [styleClass]="isMobile ? 'full-screen-mode' : ''"
  >
    <app-user-form
      [data]="user"
      [mode]="mode"
      [country]="country"
      [usernamePrefix]="usernamePrefix"
      (cancelForm)="close()"
      (submitForm)="updateUser($event)"
    ></app-user-form>
  </p-dialog>
}
